<template>
    <div class="element-video is-empty">
        <video-embed :src="link" v-if="link"></video-embed>
    </div>
</template>

<script>
    import store from '../../store'
    import Video from '../../../components/Video'

    export default {
        props: {
            element: {type: Object, required: true},
            definition: {type: Object, required: true}
        },
        computed: {
            link() {
                return this.smartlink ? this.smartlink : this.options('link') 
            },
            smartlink() { 
                return this.options('smartlink') ? store.getters.smartlink(this.options('smartlink'), this.element, 'url') : ''
            },
        },
        methods: {
            classes(index) { return store.getters['classes'](index) },
            options(value) { return store.getters['options'](this.definition, value) },
        },
        components: {
            'video-embed': Video,
        }
    }
</script>
